import type { ReactElement } from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EmailIcon from '@mui/icons-material/Email';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import RvHookupIcon from '@mui/icons-material/RvHookup';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import GroupIcon from '@mui/icons-material/Group';
import PublishIcon from '@mui/icons-material/Publish';
import FolderIcon from '@mui/icons-material/Folder';
import TuneIcon from '@mui/icons-material/Tune';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import FeedbackIcon from '@mui/icons-material/FeedbackOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import RuleIcon from '@mui/icons-material/Rule';
import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import EditNoteIcon from '@mui/icons-material/EditNote';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import GppMaybeIcon from '@mui/icons-material/GppMaybeOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TableChartIcon from '@mui/icons-material/TableChart';
import MenuBookIcon from '@mui/icons-material/MenuBook';

/**
 * Ikony pozycji menu. Wydzielone z układu, żeby `menuConfig.ts` został
 * czystymi danymi i dał się testować bez renderowania Reacta.
 *
 * Dobór ikon odwzorowuje FreightFusion tam, gdzie zasób istnieje po obu
 * stronach. Zapis pochodzenia: PORT-FROM-TLSAPP.md
 */
const ICONS: Record<string, ReactElement> = {
  'user-offers': <AssignmentIcon />,
  emails: <EmailIcon />,
  'pre-orders': <DescriptionIcon />,
  orders: <AssignmentIcon />,
  'via-orders': <LocalShippingIcon />,
  cars: <DirectionsCarIcon />,
  'fleet-schedule': <ViewTimelineIcon />,
  trailers: <RvHookupIcon />,
  drivers: <PersonIcon />,
  contractors: <BusinessIcon />,
  carriers: <LocalShippingIcon />,
  'user-offer-publishers': <PublishIcon />,
  users: <GroupIcon />,
  companies: <BusinessIcon />,
  'suggestion-parameters': <TuneIcon />,
  'feature-flags': <ToggleOnIcon />,
  'execution-department-mappings': <AltRouteIcon />,
  'truck-bans': <EventBusyIcon />,
  'trade-dashboard': <DashboardIcon />,
  'trade-transfer-reasons': <RuleIcon />,
  notifications: <NotificationsIcon />,
  'ftl-notes': <FeedbackIcon />,
  'ftl-planner-dashboard': <SpaceDashboardIcon />,
  'ftl-team-leader-dashboard': <SpaceDashboardIcon />,
  'intake-dashboard': <FactCheckIcon />,
  'order-changes': <EditNoteIcon />,
  'fuel-surcharges': <LocalGasStationIcon />,
  'publication-exceptions': <GppMaybeIcon />,
  // Kolejka CS (fala C, 21.10.2026).
  'cs-queue': <SupportAgentIcon />,
  // Komunikacja z klientem (26.10.2026, pakiet P1).
  'client-avizations': <PhoneInTalkIcon />,
  'avization-calendar': <CalendarMonthIcon />,
  'client-updates': <MarkEmailReadIcon />,
  // Raporty dla klientów (26.10.2026, P2).
  'client-reports': <SummarizeIcon />,
  'client-report-configs': <TableChartIcon />,
  // Rozliczenie zlecenia (prace 26.10.2026, P4b).
  settlements: <ReceiptLongIcon />,
  // Centrum ról i uprawnień (22.10.2026).
  'role-center': <ManageAccountsIcon />,
  // Pomiar użycia (22.10.2026, S-22.10-02).
  'usage-analytics': <QueryStatsIcon />,
  // Instrukcja obsługi (28.10.2026, S-28.10-02).
  manual: <MenuBookIcon />,
};

/** Ikona zasobu; dla nieznanego zwraca neutralny folder zamiast pustki. */
export const resourceIcon = (resource: string): ReactElement =>
  ICONS[resource] ?? <FolderIcon />;
